module.exports = new __parcel__URL__("meme-2.973ab2d1.png").toString();